import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import styles from './Settings.module.scss';
import BlackListIcon from '../../assets/ban.svg';
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import DialogComponent from "./DialogComponent";
import DeleteUserForm from "../forms/DeleteUser";
const DeleteUserButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTypedTranslation();
    return (_jsxs("button", { className: styles.button, children: [_jsxs("div", { className: styles.button__content, onClick: () => setIsOpen(true), children: [_jsx(BlackListIcon, { color: "red" }), _jsx("span", { children: t('deleteAccount') })] }), _jsx(DialogComponent, { isOpen: isOpen, onClose: () => setIsOpen(false), children: _jsx(DeleteUserForm, {}) })] }));
};
export default DeleteUserButton;
